import {
  loopbackGet,
  loopbackPost,
} from '..';
import {
  TrialTag,
} from '../../redux/types';

import { DefaultDataType as ComboboxDataType } from '../../components/layout/ComboBox';

/** restricted to admin only */
export const getTrialTags = (): Promise<TrialTag[]> => loopbackGet('TrialTags');

/**
 *
 * @param {number} trialId
 * @param {ComboboxDataType[]} trialTags
 */
export const setTrialTagMapping = (
  trialId: number,
  trialTags?: ComboboxDataType[],
): void => {
  loopbackPost('TrialTagMappings/setTagMapping', { trialId, tags: trialTags || [] });
};
